var Schedule = /** @class */ (function () {
    function Schedule(props) {
        Object.assign(this, props);
    }
    return Schedule;
}());
export default Schedule;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Schedules/Model.ts
// module id = 719
// module chunks = 0